import clsx from 'clsx';
import { KTIcon } from '../../../helpers';
import { ThemeModeComponent } from '../../../assets/ts/layout';
import { type ThemeModeType, useThemeMode } from './ThemeModeProvider';

type Props = {
  toggleBtnClass?: string;
  toggleBtnIconClass?: string;
  menuPlacement?: string;
  menuTrigger?: string;
};

const systemMode = ThemeModeComponent.getSystemMode() as 'light' | 'dark';

const ThemeModeSwitcher = ({
  toggleBtnClass = '',
  toggleBtnIconClass = 'fs-1',
  menuPlacement = 'bottom-end',
  menuTrigger = "{default: 'click', lg: 'hover'}",
}: Props) => {
  const { mode, menuMode, updateMode, updateMenuMode } = useThemeMode();
  const calculatedMode = mode === 'system' ? systemMode : mode;
  const switchMode = (_mode: ThemeModeType, event?: React.MouseEvent) => {
    if (event) {
      event.preventDefault();
    }
    updateMenuMode(_mode);
    updateMode(_mode);
  };

  return (
    <>
      {/* begin::Menu toggle */}
      <a
        className={clsx('btn btn-icon ', toggleBtnClass)}
        data-kt-menu-attach="parent"
        data-kt-menu-placement={menuPlacement}
        data-kt-menu-trigger={menuTrigger}
        href="#"
      >
        {calculatedMode === 'dark' && (
          <KTIcon className={clsx('theme-light-hide', toggleBtnIconClass)} iconName="moon" />
        )}

        {calculatedMode === 'light' && (
          <KTIcon className={clsx('theme-dark-hide', toggleBtnIconClass)} iconName="night-day" />
        )}
      </a>
      {/* begin::Menu toggle */}

      {/* begin::Menu */}
      <div
        className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-175px"
        data-kt-menu="true"
      >
        {/* begin::Menu item */}
        <div className="menu-item px-3 my-0">
          <a
            className={clsx('menu-link px-3 py-2', { active: menuMode === 'light' })}
            href="#"
            onClick={(e) => switchMode('light', e)}
          >
            <span className="menu-icon" data-kt-element="icon">
              <KTIcon className="fs-1" iconName="night-day" />
            </span>
            <span className="menu-title">Light</span>
          </a>
        </div>
        {/* end::Menu item */}

        {/* begin::Menu item */}
        <div className="menu-item px-3 my-0">
          <a
            className={clsx('menu-link px-3 py-2', { active: menuMode === 'dark' })}
            href="#"
            onClick={(e) => switchMode('dark', e)}
          >
            <span className="menu-icon" data-kt-element="icon">
              <KTIcon className="fs-1" iconName="moon" />
            </span>
            <span className="menu-title">Dark</span>
          </a>
        </div>
        {/* end::Menu item */}

        {/* begin::Menu item */}
        <div className="menu-item px-3 my-0">
          <a
            className={clsx('menu-link px-3 py-2', { active: menuMode === 'system' })}
            href="#"
            onClick={(e) => switchMode('system', e)}
          >
            <span className="menu-icon" data-kt-element="icon">
              <KTIcon className="fs-1" iconName="screen" />
            </span>
            <span className="menu-title">System</span>
          </a>
        </div>
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </>
  );
};

export { ThemeModeSwitcher };
